<div class="dialog-container">

  <!-- Header -->
  <div class="dialog-header">
    <span class="dialog-title">Sugestão de Agrupamento</span>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Config bar -->
  <div class="config-bar">
    <mat-form-field appearance="outline" class="input-tg janela-field">
      <mat-label>Janela de tempo (min)</mat-label>
      <input matInput type="number" [(ngModel)]="janelaMinutos" min="15" max="480" step="15" />
    </mat-form-field>

    <div class="agrupamento-flags">
      <mat-checkbox [(ngModel)]="agruparPorOrigem">Origem</mat-checkbox>
      <mat-checkbox [(ngModel)]="agruparPorDestino">Destino</mat-checkbox>
      <mat-checkbox [(ngModel)]="agruparPorVoo">Voo</mat-checkbox>
    </div>

    <button mat-button class="btn-tg" (click)="gerar()" [disabled]="loading">
      <mat-icon>auto_awesome</mat-icon>
      @if (loading && state === 'idle') { Gerando... } @else { Gerar Sugestão }
    </button>

    @if (state === 'generated') {
      <button mat-button class="btn-tg btn-confirm" (click)="confirmar()" [disabled]="loading">
        <mat-icon>check_circle</mat-icon>
        Confirmar Agrupamento
      </button>
    }
  </div>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- Idle state -->
  @if (state === 'idle' && !loading) {
    <div class="idle-state">
      <mat-icon class="idle-icon">group_work</mat-icon>
      <p>Configure a janela de tempo e clique em "Gerar Sugestão" para iniciar.</p>
    </div>
  }

  <!-- Results -->
  @if (state !== 'idle') {
    <div class="results-container">

      <!-- Grupos -->
      <div class="grupos-section">
        <div class="section-heading">
          <span>Grupos</span>
          <span class="count-badge">{{ grupos.length }}</span>
        </div>

        <div class="grupos-scroll">
          @for (grupo of grupos; track grupo.itemPropostaId) {
            <div class="grupo-card">
              <div class="grupo-header">
                <div class="grupo-meta">
                  <span class="grupo-veiculo">{{ grupo.tipoVeiculoDescricao }}</span>
                  <span class="grupo-info-text">
                    {{ grupo.data }} &bull; {{ grupo.horaInicio }} – {{ grupo.horaFinal }}
                    @if (grupo.voo) { &bull; <span class="grupo-voo">{{ grupo.voo }}</span> }
                  </span>
                </div>
                <span class="pax-badge" [ngClass]="{ 'pax-full': grupo.passageiros.length >= grupo.capacidade }">
                  {{ grupo.passageiros.length }} / {{ grupo.capacidade }} PAX
                </span>
              </div>

              <div class="passageiros-list">
                @for (passageiro of grupo.passageiros; track passageiro.id) {
                  <div class="passageiro-row">

                    <div class="passageiro-info">
                      @if (passageiro.speaker) {
                        <mat-icon class="speaker-icon" matTooltip="Speaker">record_voice_over</mat-icon>
                      }
                      @if (passageiro.multiploTrecho) {
                        <mat-icon class="flag-icon flag-multiplo" matTooltip="Múltiplo trecho">alt_route</mat-icon>
                      }
                      @if (passageiro.repetida) {
                        <mat-icon class="flag-icon flag-repetida" matTooltip="Passageiro duplicado">content_copy</mat-icon>
                      }
                      <span class="passageiro-nome">{{ passageiro.nome }}</span>
                      <span class="passageiro-hora">{{ passageiro.hora }}</span>
                    </div>

                    <div class="passageiro-actions">
                      <button class="btn-icon"
                        [matTooltip]="'Mover para outro grupo'"
                        [disabled]="grupos.length <= 1 || loading"
                        (click)="openMoverDialog(grupo, passageiro)">
                        <mat-icon>swap_horiz</mat-icon>
                      </button>
                      <button class="btn-icon btn-danger"
                        [matTooltip]="'Remover do grupo'"
                        [disabled]="loading"
                        (click)="onRemove(grupo, passageiro)">
                        <mat-icon>person_remove</mat-icon>
                      </button>
                    </div>

                  </div>
                }

                @if (grupo.passageiros.length === 0) {
                  <div class="empty-group-msg">Sem passageiros neste grupo</div>
                }
              </div>
            </div>
          }

          @if (grupos.length === 0) {
            <div class="empty-state">
              <mat-icon>inbox</mat-icon>
              <p>Nenhum grupo foi gerado.</p>
            </div>
          }
        </div>
      </div>

      <!-- Sem correspondência -->
      <div class="sem-correspondencia-section">
        <div class="section-heading">
          <span>Sem Correspondência</span>
          <span class="count-badge count-badge-warn">{{ semCorrespondencia.length }}</span>
        </div>

        <div class="sc-scroll">
          @for (p of semCorrespondencia; track p.id) {
            <div class="sc-row">
              <div class="passageiro-info">
                @if (p.multiploTrecho) {
                  <mat-icon class="flag-icon flag-multiplo" matTooltip="Múltiplo trecho">alt_route</mat-icon>
                }
                @if (p.repetida) {
                  <mat-icon class="flag-icon flag-repetida" matTooltip="Passageiro duplicado">content_copy</mat-icon>
                }
                <span class="passageiro-nome">{{ p.nome }}</span>
                <span class="passageiro-hora">{{ p.hora }}</span>
              </div>
              @if (p.motivo) {
                <span class="motivo-text">{{ p.motivo }}</span>
              }
              @if (p.sugerirCriarItemProposta) {
                <button mat-button class="btn-criar-item" (click)="criarItemProposta(p)">
                  <mat-icon>add_circle_outline</mat-icon>
                  Criar Item
                </button>
              }
            </div>
          }

          @if (semCorrespondencia.length === 0) {
            <div class="empty-state">
              <mat-icon>check_circle_outline</mat-icon>
              <p>Todos os passageiros foram agrupados.</p>
            </div>
          }
        </div>
      </div>

    </div>
  }

</div>
